import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Tanpura from "@/pages/Tanpura";
import Taals from "@/pages/Taals";
import Metronome from "@/pages/Metronome";
import Tuner from "@/pages/Tuner";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Landing />} />
                        <Route path="/tanpura" element={<Tanpura />} />
                        <Route path="/taals" element={<Taals />} />
                        <Route path="/metronome" element={<Metronome />} />
                        <Route path="/tuner" element={<Tuner />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
